import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';

export default function OrderEntry() {
  const [params] = useSearchParams();
  const tokenClassId = params.get('token_class_id');
  if (!tokenClassId) return <Navigate to="/markets" replace />;
  return <Navigate to={`/markets/${tokenClassId}`} replace />;
}
